import { createSlice, createSelector } from "@reduxjs/toolkit";

const initialState = {
  soundBlockLevel: null,
  eklokData: null,
  commandList: {
    all: null,
    routines: null,
    musics: null,
    melodies: null,
    favorites: null,
    musicsSynth: null,
  },
};

const slice = createSlice({
  name: "manualCommandList",
  initialState: initialState,
  reducers: {
    setManualCommandList: (state, action) => {
      const actionList = action.payload.data?.data?.ACTION_LIST;
      const routines = actionList?.filter(
        (item) => item.ACTION_TYPE === "ACTIONS",
      );
      const musics = actionList?.filter(
        (item) => item.ACTION_TYPE === "MUSICS",
      );
      const musicsSynth = actionList?.filter(
        (item) => item.ACTION_TYPE === "MUSICS_SYNTH",
      );
      const melodies = actionList?.filter(
        (item) => item.ACTION_TYPE === "MELODIES",
      );
      const favorites = actionList?.filter((item) => item.IS_FAVORITE === true);
      state.commandList.all = actionList;
      state.commandList.routines = routines;
      state.commandList.musics = musics;
      state.commandList.melodies = melodies;
      state.commandList.favorites = favorites;
      state.commandList.musicsSynth = musicsSynth;
    },
    setEklokData: (state, action) => {
      state.eklokData = action.payload.data.data;
    },
    setSoundBlockLevel: (state, action) => {
      state.soundBlockLevel = action.payload;
    },
    resetManualCommandListState: () => initialState,
  },
});

export const getEklokDataSelector = createSelector(
  (state) => state.manualCommandList,
  (manualCommandList) => manualCommandList.eklokData,
);

export const getSoundBlockLevelSelector = createSelector(
  (state) => state.manualCommandList,
  (manualCommandList) => manualCommandList.soundBlockLevel,
);

export const {
  setManualCommandList,
  setEklokData,
  setSoundBlockLevel,
  resetManualCommandListState,
} = slice.actions;

export default slice.reducer;
